@if (isAuthRoute()) {
  <app-auth-background />
}
<router-outlet></router-outlet>
@if (!isAuthRoute()) {
  <app-footer />
}
<lib-toast></lib-toast>
